import type { RequestApiError } from "./types";

export function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

export function isRequestApiError(value: unknown): value is RequestApiError {
  return (
    typeof value === "object" &&
    value !== null &&
    "code" in value &&
    "message" in value &&
    "status" in value &&
    "data" in value
  );
}
